export default "__VITE_ASSET__BMqQcHYp__"